import { useMutation } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

/** Select shown in the header when the user belongs to more than one household. */
export function HouseholdSwitcher() {
  const { auth, refresh } = useAuth();
  const switchTo = useMutation({
    mutationFn: (householdId: string) => api.households.switch({ householdId }),
    onSuccess: () => refresh(),
  });
  if (auth.status !== 'authed' || auth.memberships.length < 2) return null;
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="sr-only">Household</span>
      <select
        value={auth.household?.id ?? ''}
        onChange={(e) => switchTo.mutate(e.target.value)}
        disabled={switchTo.isPending}
        className="min-h-9 max-w-40 rounded-md border border-line bg-surface px-2 text-sm"
      >
        {auth.memberships.map((m) => (
          <option key={m.household.id} value={m.household.id}>
            {m.household.name}
          </option>
        ))}
      </select>
    </label>
  );
}
